<template>
  <div>
    <v-icon
      color="error"
      @click="deleteRule"
    >mdi-delete</v-icon>
  </div>
</template>

<script>
  export default {
    props: {
      rule: {
        type: Object,
        default: null
      },
    },
    methods: {
      deleteRule() {
        if(confirm('Tem certeza que deseja excluir esta regra?')) {
          this.$http.delete(`api/collect-partner-rules/${this.rule.id}`)
          .then(() => {
            this.$side({
              type    : 'success',
              msg     : 'Removido com sucesso',
              duration: 4000
            });

            this.$emit('removed');
          }).catch(err => {
            console.log(err);

            this.$side({
              type    : 'error',
              msg     : 'Erro ao remover regra',
              duration: 4000
            });
          });
        }
      }
    },
  }
</script>

<style scoped>

</style>